export default "__VITE_ASSET__nCoff4YB__"